module.exports = __webpack_public_path__ + "img/ping.3b3f87af.png";